import { render, staticRenderFns } from "./SaleDetails.vue?vue&type=template&id=4396168e&scoped=true&lang=pug&"
import script from "./SaleDetails.vue?vue&type=script&lang=js&"
export * from "./SaleDetails.vue?vue&type=script&lang=js&"
import style0 from "./SaleDetails.vue?vue&type=style&index=0&id=4396168e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4396168e",
  null
  
)

component.options.__file = "SaleDetails.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VAvatar,
  VChip,
  VIcon,
})
